import type { IconSvgObject } from './types';

const MagicWand03Icon: IconSvgObject = [
  ["path", { d: "M9.24277 6.38718L4 4.25L6 9.25L2.5 13.25H8L10.5 18.75L12.5 12.75L18.5 10.75L13.5 8.25L13 2.25L9.24277 6.38718Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 15.25L16.5 16.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.9391 19.3093C16.3536 18.7239 16.3536 17.7746 16.9391 17.1891C17.5246 16.6036 18.4739 16.6036 19.0593 17.1891L21.0609 19.1907C21.6464 19.7761 21.6464 20.7254 21.0609 21.3109C20.4754 21.8964 19.5261 21.8964 18.9407 21.3109L16.9391 19.3093Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "bevel", strokeWidth: "1.5", key: "2" }]
];

export default MagicWand03Icon;
